module.exports = __webpack_public_path__ + "media/assets/images/bg-modal-007eb37bc020707b5d44be98844fcf43.svg";